'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection(eyebrow, title, cards) {
  this.iT = null;
  this.iU = null;
  this.iS = null;
  this.iT = eyebrow;
  this.iU = title;
  this.iS = cards;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection as $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$ValueSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$ValueSection as $h_Lio_intela_sites_digitalinternship_data_Segments$ValueSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$ValueSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 142060287, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection)) {
    if (((this.iT === x$0.iT) && (this.iU === x$0.iU))) {
      var x = this.iS;
      var x$2 = x$0.iS;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "ValueSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iT;
      break;
    }
    case 1: {
      return this.iU;
      break;
    }
    case 2: {
      return this.iS;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bQ)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ValueSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$ValueSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$ValueSection, "io.intela.sites.digitalinternship.data.Segments$ValueSection", ({
  bQ: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$ValueSection as $d_Lio_intela_sites_digitalinternship_data_Segments$ValueSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Value-Section.js.map
